import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  fr: {
    // Nav
    "nav.brand_suffix": "Inc.",
    "nav.tagline": "Restauration & teinture",
    "nav.services": "Services",
    "nav.prevention": "Prévention",
    "nav.gallery": "Galerie",
    "nav.process": "Processus",
    "nav.zones": "Zones",
    "nav.contact": "Contact",
    "nav.cta_quote": "Soumission gratuite",
    "nav.menu": "Menu",

    // Hero
    "hero.eyebrow": "Restauration · Sablage · Teinture",
    "hero.title_l1": "Le bois rond,",
    "hero.title_l2": "remis à neuf.",
    "hero.lead":
      "AGL Bois Rond Inc. redonne vie à vos chalets, maisons en billots et structures extérieures. Sablage en profondeur, réparation des bois pourris, calfeutrage étanche et teintures haut de gamme — pour un fini qui traverse les saisons.",
    "hero.cta_quote": "Soumission gratuite",
    "hero.cta_sms": "Texto direct",
    "hero.logo_caption": "Spécialistes du bois rond",
    "hero.badge_warranty": "Travail garanti",
    "hero.badge_specialist": "Spécialistes bois rond",
    "hero.badge_premium": "Produits haut de gamme",
    "hero.badge_zone": "Laurentides & + loin",

    // Services
    "services.eyebrow": "— Nos services",
    "services.title_l1": "Tout ce que votre chalet",
    "services.title_l2": "mérite.",
    "services.intro":
      "Du sablage à la finition, en passant par la réparation des billots et le calfeutrage professionnel — un service complet, exécuté avec soin par des spécialistes.",
    "services.custom_lead": "Vous avez un projet hors norme ? Parlons-en.",
    "services.custom_cta": "Demander une soumission",
    "service.sablage.title": "Sablage",
    "service.sablage.sub": "Décapage en profondeur",
    "service.sablage.desc":
      "Sablage par média adapté à chaque essence : on retire la vieille teinture, les taches noires et le grisonnement sans abîmer le grain du bois rond.",
    "service.sablage.b1": "Médias doux & abrasifs",
    "service.sablage.b2": "Préservation du grain",
    "service.sablage.b3": "Surfaces remises à neuf",
    "service.teinture.title": "Teinture & vernissage",
    "service.teinture.sub": "Protection longue durée",
    "service.teinture.desc":
      "Application professionnelle de teintures, scellants et vernis haut de gamme conçus pour résister aux hivers rigoureux et au soleil estival.",
    "service.teinture.b1": "Teintures Sansin · Sashco · Permachink",
    "service.teinture.b2": "Couches uniformes",
    "service.teinture.b3": "Garantie de tenue",
    "service.reparation.title": "Réparation de bois",
    "service.reparation.sub": "Billots & madriers",
    "service.reparation.desc":
      "Remplacement de billots pourris, greffes en époxy structural, reconstruction de coins et de poteaux. On redonne vie à votre chalet.",
    "service.reparation.b1": "Billots & rondins",
    "service.reparation.b2": "Réparations structurales",
    "service.reparation.b3": "Restauration de poteaux",
    "service.calfeutrage.title": "Calfeutrage (chinking)",
    "service.calfeutrage.sub": "Étanchéité entre billots",
    "service.calfeutrage.desc":
      "Calfeutrage et chinking entre les rondins pour bloquer infiltrations d'air, d'eau et insectes — fini propre, rectiligne, durable.",
    "service.calfeutrage.b1": "Mastic Sashco / Permachink",
    "service.calfeutrage.b2": "Joints souples & étanches",
    "service.calfeutrage.b3": "Économies d'énergie",

    // Vermin prevention
    "vermin.eyebrow": "— Prévention vermine",
    "vermin.title_l1": "Le bois attire",
    "vermin.title_l2": "les insectes.",
    "vermin.intro":
      "Fourmis charpentières, vrillettes, longicornes, termites — plusieurs insectes s'attaquent au bois d'œuvre, souvent en silence pendant des années. Un chalet en bois rond, s'il n'est pas surveillé, peut perdre sa solidité structurelle sans qu'aucun signe évident n'apparaisse à l'œil nu.",
    "vermin.signs_title": "3 signes à surveiller sur votre chalet",
    "vermin.sign1.t": "Petits trous ronds",
    "vermin.sign1.d": "Perforations de 1 à 3 mm dans les billots ou madriers — la porte de sortie des larves qui creusent le bois de l'intérieur.",
    "vermin.sign2.t": "Tas de sciure fine",
    "vermin.sign2.d": "Petits monticules de poussière de bois (comme de la farine) sous les trous ou aux coins de plancher — c'est la sciure éjectée par les insectes.",
    "vermin.sign3.t": "Bruits ou galeries visibles",
    "vermin.sign3.d": "Bruits de grattement (surtout la nuit), fourmis noires près du bois, ou galeries lisses creusées dans les billots.",
    "vermin.insects_title": "Les principaux coupables",
    "vermin.insect1.t": "Fourmis charpentières",
    "vermin.insect1.d": "Elles ne mangent pas le bois — elles y creusent des galeries pour nicher. Les colonies peuvent compter des milliers d'individus et affaiblir la structure.",
    "vermin.insect2.t": "Vrillettes & lyctus",
    "vermin.insect2.d": "Petits coléoptères dont les larves creusent le bois pendant des années avant d'émerger. Redoutables sur les billots secs et anciens.",
    "vermin.insect3.t": "Longicornes",
    "vermin.insect3.d": "Grands coléoptères aux longues antennes. Leurs larves peuvent causer des dommages majeurs à la charpente en quelques années.",
    "vermin.insect4.t": "Termites",
    "vermin.insect4.d": "Rares mais présents au Québec. Signalement obligatoire dans certaines régions. Traitement urgent requis dès la moindre suspicion.",
    "vermin.approach_title": "Notre approche complète",
    "vermin.approach1.t": "Inspection gratuite",
    "vermin.approach1.d": "Nous inspectons votre chalet de fond en comble et identifions les zones à risque, les insectes présents et l'ampleur des dégâts.",
    "vermin.approach2.t": "Évaluation détaillée",
    "vermin.approach2.d": "Rapport clair avec photos, recommandations et estimation des travaux de traitement et de restauration.",
    "vermin.approach3.t": "Traitement au borax",
    "vermin.approach3.d": "Application d'un traitement répulsif au borax qui pénètre en profondeur dans le bois — protège contre les insectes xylophages et les organismes responsables de sa dégradation.",
    "vermin.approach4.t": "Conseils & suivi",
    "vermin.approach4.d": "Nous vous guidons sur l'entretien préventif, le contrôle de l'humidité et les meilleures pratiques pour protéger votre chalet.",
    "vermin.cta_lead": "Un doute ? Une inspection gratuite peut vous sauver des milliers de dollars en réparations.",
    "vermin.cta_btn": "Réserver mon inspection gratuite",

    // Gallery
    "gallery.eyebrow": "— Avant · Après",
    "gallery.title_l1": "La différence se voit,",
    "gallery.title_l2": "elle se touche.",
    "gallery.intro":
      "Glissez la barre pour découvrir une de nos restaurations récentes : un chalet rongé par les saisons, ramené à neuf grâce au sablage, à la teinture neuve et au calfeutrage.",
    "gallery.before": "Avant",
    "gallery.after": "Après",
    "gallery.realisation": "Réalisation",
    "gallery.cabin_caption": "Chalet d'automne — Laurentides",

    // Values
    "values.eyebrow": "— Pourquoi nous choisir",
    "values.title_l1": "Du métier,",
    "values.title_l2": "de la rigueur.",
    "values.intro":
      "Le bois rond, c'est notre quotidien. On connaît les nœuds, les fissures, les vents qui sèchent et les hivers qui mordent. Chaque chantier est traité comme s'il s'agissait de notre propre chalet.",
    "value.specialists.t": "Spécialistes du bois rond",
    "value.specialists.d": "Notre expertise : chalets en billots, madriers et structures forestières.",
    "value.warranty.t": "Travail garanti",
    "value.warranty.d": "Produits haut de gamme, application professionnelle, résultat durable.",
    "value.detail.t": "Soin du détail",
    "value.detail.d": "Joints rectilignes, finition uniforme, propreté du chantier respectée.",
    "value.mobility.t": "Mobilité élargie",
    "value.mobility.d": "Laurentides, Rive-Nord et régions éloignées : on se déplace là où il faut.",

    // Process
    "process.eyebrow": "— Comment ça marche",
    "process.title": "Du devis au coup de pinceau final.",
    "step.1.t": "Inspection & devis",
    "step.1.d": "Visite sur site (ou photos), évaluation de l'état du bois et soumission claire.",
    "step.2.t": "Préparation",
    "step.2.d": "Protection des fenêtres, du toit et du paysage. Sablage minutieux du bois.",
    "step.3.t": "Réparation & calfeutrage",
    "step.3.d": "Remplacement des billots abîmés et chinking étanche entre les rondins.",
    "step.4.t": "Teinture & finition",
    "step.4.d": "Application de la teinture/scellant en plusieurs couches selon spécifications.",

    // Zones
    "zones.eyebrow": "— Zones desservies",
    "zones.title": "Présents là où le bois rond pousse.",
    "zones.intro":
      "Nous couvrons les Laurentides, la Rive-Nord et nous nous déplaçons dans les régions éloignées sur demande. Un chalet au fond du bois ? Pas un problème.",
    "zone.remote": "Régions éloignées",
    "zone.rivenord": "Rive-Nord",

    // Contact
    "contact.eyebrow": "— Soumission",
    "contact.title_l1": "Demandez votre",
    "contact.title_l2": "soumission gratuite.",
    "contact.intro":
      "Décrivez votre projet et joignez des photos de votre chalet — plus on en sait, plus la soumission sera précise. Réponse personnalisée, sans frais ni engagement.",
    "contact.zones": "Laurentides · Rive-Nord · Régions éloignées sur demande",
    "contact.hours": "Lun – Sam · sur rendez-vous",
    "contact.sms": "Texto rapide",
    "form.name": "Nom complet",
    "form.email": "Courriel",
    "form.phone": "Téléphone",
    "form.service": "Type de service",
    "form.service_placeholder": "Sélectionnez un service",
    "form.address": "Adresse / municipalité",
    "form.message": "Décrivez votre projet",
    "form.message_placeholder": "Type de bâtiment, dimensions approximatives, état du bois, délais souhaités...",
    "form.photos": "Photos du chalet",
    "form.photos_optional": "facultatif",
    "form.add_photos": "Ajouter des photos",
    "form.uploading": "Téléversement...",
    "form.photos_hint": "JPG, PNG, WebP — max 5 Mo / photo",
    "form.required_note": "* champs obligatoires",
    "form.submit": "Envoyer ma demande",
    "form.submitting": "Envoi...",
    "form.toast_success": "Demande envoyée — nous vous répondons rapidement.",
    "form.toast_error": "Une erreur est survenue. Appelez-nous au ",
    "form.toast_required": "Veuillez remplir les champs obligatoires.",
    "form.toast_max_photos": "Maximum 10 photos.",
    "form.toast_too_big": "dépasse 5 Mo",
    "form.toast_upload_fail": "Échec : ",
    "service.option.sablage": "Sablage",
    "service.option.teinture": "Teinture & vernissage",
    "service.option.reparation": "Réparation de bois",
    "service.option.calfeutrage": "Calfeutrage (chinking)",
    "service.option.complete": "Restauration complète",
    "service.option.other": "Autre projet sur mesure",

    // Footer
    "footer.about":
      "Spécialistes de la restauration du bois rond extérieur. Sablage, teinture, réparations et calfeutrage — pour des chalets qui durent.",
    "footer.services": "Services",
    "footer.contact": "Contact",
    "footer.sms": "Texto / SMS",
    "footer.rights": "Tous droits réservés.",
    "footer.tagline": "Le bois rond, remis à neuf.",
    "footer.s1": "Sablage du bois",
    "footer.s2": "Teinture & vernissage",
    "footer.s3": "Réparation de billots",
    "footer.s4": "Calfeutrage (chinking)",
  },

  en: {
    // Nav
    "nav.brand_suffix": "Inc.",
    "nav.tagline": "Restoration & staining",
    "nav.services": "Services",
    "nav.prevention": "Prevention",
    "nav.gallery": "Gallery",
    "nav.process": "Process",
    "nav.zones": "Areas",
    "nav.contact": "Contact",
    "nav.cta_quote": "Free quote",
    "nav.menu": "Menu",

    // Hero
    "hero.eyebrow": "Restoration · Sandblasting · Staining",
    "hero.title_l1": "Log wood,",
    "hero.title_l2": "renewed.",
    "hero.lead":
      "AGL Bois Rond Inc. brings cabins, log homes and outdoor wood structures back to life. Deep sandblasting, rotten log repair, weather-tight chinking and premium stains — for a finish that endures every season.",
    "hero.cta_quote": "Free quote",
    "hero.cta_sms": "Text us",
    "hero.logo_caption": "Log wood specialists",
    "hero.badge_warranty": "Workmanship guaranteed",
    "hero.badge_specialist": "Log wood specialists",
    "hero.badge_premium": "Premium products",
    "hero.badge_zone": "Laurentians & beyond",

    // Services
    "services.eyebrow": "— Our services",
    "services.title_l1": "Everything your cabin",
    "services.title_l2": "deserves.",
    "services.intro":
      "From sandblasting to the final coat — including log repair and professional chinking. A complete service delivered with care by specialists.",
    "services.custom_lead": "Have an unusual project? Let's talk.",
    "services.custom_cta": "Request a quote",
    "service.sablage.title": "Sandblasting",
    "service.sablage.sub": "Deep stripping",
    "service.sablage.desc":
      "Media-blasting matched to each wood species: we remove old stain, black tannin marks and graying without damaging the log's grain.",
    "service.sablage.b1": "Soft & abrasive media",
    "service.sablage.b2": "Grain preservation",
    "service.sablage.b3": "Like-new surfaces",
    "service.teinture.title": "Staining & sealing",
    "service.teinture.sub": "Long-term protection",
    "service.teinture.desc":
      "Professional application of premium stains, sealers and varnishes designed to withstand harsh winters and summer sun.",
    "service.teinture.b1": "Sansin · Sashco · Permachink stains",
    "service.teinture.b2": "Even, uniform coats",
    "service.teinture.b3": "Wear-resistance guarantee",
    "service.reparation.title": "Wood repair",
    "service.reparation.sub": "Logs & timbers",
    "service.reparation.desc":
      "Replacement of rotten logs, structural epoxy splicing, rebuilding of corners and posts. We bring your cabin back to life.",
    "service.reparation.b1": "Logs & rounds",
    "service.reparation.b2": "Structural repairs",
    "service.reparation.b3": "Post & corner rebuilds",
    "service.calfeutrage.title": "Chinking",
    "service.calfeutrage.sub": "Sealed between logs",
    "service.calfeutrage.desc":
      "Caulking and chinking between logs to block air, water and insect infiltration — clean, straight, lasting joints.",
    "service.calfeutrage.b1": "Sashco / Permachink sealants",
    "service.calfeutrage.b2": "Flexible, watertight joints",
    "service.calfeutrage.b3": "Energy savings",

    // Vermin prevention
    "vermin.eyebrow": "— Vermin prevention",
    "vermin.title_l1": "Wood attracts",
    "vermin.title_l2": "insects.",
    "vermin.intro":
      "Carpenter ants, powder-post beetles, longhorn beetles, termites — several insects attack wooden structures, often silently for years. A log cabin, if left unmonitored, can lose its structural integrity without any obvious sign to the naked eye.",
    "vermin.signs_title": "3 warning signs to watch on your cabin",
    "vermin.sign1.t": "Small round holes",
    "vermin.sign1.d": "1 to 3 mm perforations in logs or timbers — the exit doors of larvae that eat wood from the inside out.",
    "vermin.sign2.t": "Fine sawdust piles",
    "vermin.sign2.d": "Small mounds of wood powder (flour-like) below holes or at floor corners — sawdust ejected by insects at work.",
    "vermin.sign3.t": "Sounds or visible tunnels",
    "vermin.sign3.d": "Scratching noises (especially at night), black ants near wood, or smooth galleries dug into the logs.",
    "vermin.insects_title": "The main culprits",
    "vermin.insect1.t": "Carpenter ants",
    "vermin.insect1.d": "They don't eat wood — they hollow out galleries to nest. Colonies can number thousands and severely weaken the structure.",
    "vermin.insect2.t": "Powder-post beetles",
    "vermin.insect2.d": "Small beetles whose larvae bore through wood for years before emerging. Devastating on dry, aged logs.",
    "vermin.insect3.t": "Longhorn beetles",
    "vermin.insect3.d": "Large beetles with long antennae. Their larvae can cause major frame damage within a few years.",
    "vermin.insect4.t": "Termites",
    "vermin.insect4.d": "Rare but present in Quebec. Reporting is mandatory in some regions. Urgent treatment required at the first suspicion.",
    "vermin.approach_title": "Our complete approach",
    "vermin.approach1.t": "Free inspection",
    "vermin.approach1.d": "We inspect your cabin thoroughly and identify risk zones, present insects and the extent of any damage.",
    "vermin.approach2.t": "Detailed evaluation",
    "vermin.approach2.d": "Clear report with photos, recommendations and estimates for treatment and restoration work.",
    "vermin.approach3.t": "Borax treatment",
    "vermin.approach3.d": "Application of a borax repellent treatment that penetrates deep into the wood — protecting against wood-boring insects and organisms responsible for degradation.",
    "vermin.approach4.t": "Advice & follow-up",
    "vermin.approach4.d": "We guide you on preventive maintenance, humidity control and best practices to protect your cabin.",
    "vermin.cta_lead": "In doubt? A free inspection can save you thousands of dollars in repairs.",
    "vermin.cta_btn": "Book my free inspection",

    // Gallery
    "gallery.eyebrow": "— Before · After",
    "gallery.title_l1": "The difference shows,",
    "gallery.title_l2": "you can feel it.",
    "gallery.intro":
      "Drag the slider to see a recent restoration: a cabin worn by the seasons, brought back to life with sandblasting, fresh stain and chinking.",
    "gallery.before": "Before",
    "gallery.after": "After",
    "gallery.realisation": "Project",
    "gallery.cabin_caption": "Autumn cabin — Laurentians",

    // Values
    "values.eyebrow": "— Why choose us",
    "values.title_l1": "Craftsmanship,",
    "values.title_l2": "rigor.",
    "values.intro":
      "Log wood is our daily craft. We know the knots, the cracks, the drying winds and the biting winters. Every job is treated as if it were our own cabin.",
    "value.specialists.t": "Log wood specialists",
    "value.specialists.d": "Our expertise: log cabins, timber homes and forest structures.",
    "value.warranty.t": "Guaranteed workmanship",
    "value.warranty.d": "Premium products, professional application, lasting results.",
    "value.detail.t": "Attention to detail",
    "value.detail.d": "Straight joints, even finish, clean job site respected.",
    "value.mobility.t": "Wide service area",
    "value.mobility.d": "Laurentians, North Shore and remote regions: we travel where it matters.",

    // Process
    "process.eyebrow": "— How it works",
    "process.title": "From the quote to the final brushstroke.",
    "step.1.t": "Inspection & quote",
    "step.1.d": "On-site visit (or photos), wood condition assessment and clear quote.",
    "step.2.t": "Preparation",
    "step.2.d": "Protect windows, roof and landscape. Careful sandblasting of the wood.",
    "step.3.t": "Repair & chinking",
    "step.3.d": "Replace damaged logs and apply weather-tight chinking between logs.",
    "step.4.t": "Stain & finish",
    "step.4.d": "Apply stain/sealer in multiple coats according to specifications.",

    // Zones
    "zones.eyebrow": "— Service areas",
    "zones.title": "Wherever log wood grows.",
    "zones.intro":
      "We cover the Laurentians, the North Shore and travel to remote regions on request. A cabin deep in the woods? Not a problem.",
    "zone.remote": "Remote regions",
    "zone.rivenord": "North Shore",

    // Contact
    "contact.eyebrow": "— Quote",
    "contact.title_l1": "Get your",
    "contact.title_l2": "free quote.",
    "contact.intro":
      "Describe your project and attach photos of your cabin — the more details, the more accurate the quote. Personalized response, no fees or commitment.",
    "contact.zones": "Laurentians · North Shore · Remote regions on request",
    "contact.hours": "Mon – Sat · by appointment",
    "contact.sms": "Quick text",
    "form.name": "Full name",
    "form.email": "Email",
    "form.phone": "Phone",
    "form.service": "Service type",
    "form.service_placeholder": "Select a service",
    "form.address": "Address / city",
    "form.message": "Describe your project",
    "form.message_placeholder": "Building type, approximate dimensions, wood condition, desired timeline...",
    "form.photos": "Cabin photos",
    "form.photos_optional": "optional",
    "form.add_photos": "Add photos",
    "form.uploading": "Uploading...",
    "form.photos_hint": "JPG, PNG, WebP — max 5 MB / photo",
    "form.required_note": "* required fields",
    "form.submit": "Send my request",
    "form.submitting": "Sending...",
    "form.toast_success": "Request sent — we'll get back to you shortly.",
    "form.toast_error": "Something went wrong. Call us at ",
    "form.toast_required": "Please fill in the required fields.",
    "form.toast_max_photos": "Maximum 10 photos.",
    "form.toast_too_big": "exceeds 5 MB",
    "form.toast_upload_fail": "Failed: ",
    "service.option.sablage": "Sandblasting",
    "service.option.teinture": "Staining & sealing",
    "service.option.reparation": "Wood repair",
    "service.option.calfeutrage": "Chinking",
    "service.option.complete": "Full restoration",
    "service.option.other": "Other custom project",

    // Footer
    "footer.about":
      "Outdoor log wood restoration specialists. Sandblasting, staining, repair and chinking — for cabins that last.",
    "footer.services": "Services",
    "footer.contact": "Contact",
    "footer.sms": "Text / SMS",
    "footer.rights": "All rights reserved.",
    "footer.tagline": "Log wood, renewed.",
    "footer.s1": "Wood sandblasting",
    "footer.s2": "Staining & sealing",
    "footer.s3": "Log repair",
    "footer.s4": "Chinking",
  },
};

const LanguageContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const saved = localStorage.getItem("agl_lang");
    if (saved === "fr" || saved === "en") return saved;
    const nav = navigator.language?.toLowerCase() || "fr";
    return nav.startsWith("en") ? "en" : "fr";
  });

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
    if (typeof window !== "undefined") localStorage.setItem("agl_lang", lang);
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "fr");
  const t = (key) => translations[lang]?.[key] ?? translations.fr[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
